<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">
            <personal pageType="personalinfo"></personal>
            <div class="personal_right">
              <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign6.png"> 个人资料</span></h2>
              <dl class="safe" style="padding-left: 13%;">
                <dd><span> 姓名：</span><em><input disabled v-model="user_info.userName" type="text"></em></dd>
                <dd><span> 身份证：</span><em><input disabled v-model="user_info.userIdcard" type="text"></em></dd>
                <dd><span> 手机号码：</span><em><input disabled v-model="user_info.userTel" type="text"></em></dd>
<!--                <dd><span> 区划：</span><em><input disabled v-model="user_info.userName" type="text"></em></dd>-->
                <dd><span> 联系地址：</span><em><input disabled v-model="user_info.userIdcardAddress" type="text"></em></dd>
<!--                <dd class="safe_button"><button>保存</button></dd>-->
              </dl>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import personal from "../../components/Personal";
  export default {
    name: "PersonalInfo",
    components: {
      headers, fixedDiv, footers,personal
    },
    data(){
      return{
        user_info:{},
        loginShow:false,
        gotoIndex:false,
      }
    },
    mounted() {
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
      }
      this.getPersonInfo()
    },
    methods:{
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      } ,
      getPersonInfo(){
        this.$https.post("/api/pu/peopleUserInfo.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            if (!this.$util.isEmpty(response.data.data)){
              this.user_info = response.data.data;
            }
            console.log(this.user_info)
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/personal/PersonalInfo.vue